import { useEffect } from 'react';
import { signupUrl } from '../utils/company';

/**
 * Las empresas se registran en el portal de Ruttia; los usuarios de cada empresa los crea su administrador.
 * Esta dirección antigua lleva al registro del portal.
 */
const Register = () => {
  useEffect(() => {
    window.location.replace(signupUrl());
  }, []);
  return null;
};

export default Register;
